import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { TreeItem2 } from '@mui/x-tree-view/TreeItem2';
import useEventContext from '@hooks/useEventContext';
import { DIVISION_STYLE } from '@type/db-types';
import { getClassLabel, getDivisionLabel } from '@utils/event-utils';

export default function DivisionVisualizer() {
    const { event } = useEventContext();

    const expandedIds = useMemo(
        () => event?.divisions?.map((division) => division.id),
        [event?.divisions],
    );

    const treeItems = useMemo(
        () =>
            event?.divisions
                ?.sort((a, b) => a.sortIndex - b.sortIndex)
                ?.map((division) => ({
                    id: division.id,
                    label: getDivisionLabel(division),
                    children:
                        division.bracketStyle === DIVISION_STYLE.MADISON_SYSTEM
                            ? [
                                  {
                                      id: `madison-${division.id}`,
                                      label: 'Madison System - no fixed weight classes',
                                  },
                              ]
                            : division.classes
                                  ?.sort((a, b) => a.sortIndex - b.sortIndex)
                                  ?.map((c) => ({
                                      id: c.id,
                                      label: getClassLabel(c),
                                  })),
                })),
        [event?.divisions],
    );

    if (!treeItems) {
        return <Typography variant="h5">No divisions found</Typography>;
    }

    return (
        <Stack>
            <Typography variant="h5" gutterBottom>
                Divisions & Weight Classes
            </Typography>
            <RichTreeView
                expandedItems={expandedIds}
                items={treeItems}
                slots={{ item: TreeItem2 }}
            />
        </Stack>
    );
}
